module.exports = __webpack_public_path__ + "static/mobile-899bb1fa20bc1dd989295085678b2c52.png";